/* tslint:disable */
import {
  Course
} from '../index';

declare var Object: any;
export interface CourseCategoryInterface {
  "name"?: string;
  "kind"?: string;
  "category"?: string;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
  course?: Course[];
}

export class CourseCategory implements CourseCategoryInterface {
  "name": string;
  "kind": string;
  "category": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  course: Course[];
  constructor(data?: CourseCategoryInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `CourseCategory`.
   */
  public static getModelName() {
    return "CourseCategory";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of CourseCategory for dynamic purposes.
  **/
  public static factory(data: CourseCategoryInterface): CourseCategory{
    return new CourseCategory(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'CourseCategory',
      plural: 'CourseCategories',
      path: 'CourseCategories',
      idName: 'id',
      properties: {
        "name": {
          name: 'name',
          type: 'string'
        },
        "kind": {
          name: 'kind',
          type: 'string'
        },
        "category": {
          name: 'category',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
        course: {
          name: 'course',
          type: 'Course[]',
          model: 'Course',
          relationType: 'hasMany',
                  keyFrom: 'id',
          keyTo: 'courseCategoryId'
        },
      }
    }
  }
}
